import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import {
  AgrBlockSpinnerModule,
  AgrFilterModule,
  AgrNotificationEmptyModule,
  AgrPageDetailModule,
  AgrPageToolbarModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { FormDialogComponent, provideAgrDialog } from '@next/core-lib/dialog';
import { AgrExportModule } from '@next/core-lib/export';
import { AgrFormModule } from '@next/core-lib/form';
import { provideAgrNotification } from '@next/core-lib/notification';
import { CustomerGuard } from '@next/core-lib/relationships';
import { TableV2Module } from '@next/core-lib/table-v2';

import { LetDirective, PushPipe } from '@ngrx/component';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { TableActionsButtonModule } from '../shared/table-actions-button/table-actions-button.module';
import { SingleInputDialogComponent } from './components/pick-up/pick-up-overview/components/single-input-dialog.component';
import { OverviewTableComponent } from './components/pick-up/pick-up-overview/overview-table/overview-table.component';
import { PickUpComponent } from './components/pick-up/pick-up.component';
import { PickUpRegistrationComponent } from './components/pick-up-registration/pick-up-registration.component';
import { PickUpRegistrationConfirmComponent } from './components/pick-up-registration-confirm/pick-up-registration-confirm.component';
import { PickUpCropInfoComponent } from './components/pick-up-registration-info/pick-up-crop-info/pick-up-crop-info.component';
import { PickUpRegistrationInfoComponent } from './components/pick-up-registration-info/pick-up-registration-info.component';
import { PickUpGuard } from './guards/pickup.guard';
import { PickUpEffects } from './store/effects/pick-up.effects';
import { reducer } from './store/reducers/pick-up.reducer';

const registrationChildren: Routes = [
  {
    path: '',
    redirectTo: 'information',
    pathMatch: 'full',
  },
  { path: 'information', component: PickUpRegistrationInfoComponent },
  { path: 'confirm', component: PickUpRegistrationConfirmComponent },
];

@NgModule({
  declarations: [
    PickUpComponent,
    PickUpRegistrationComponent,
    PickUpRegistrationInfoComponent,
    PickUpRegistrationConfirmComponent,
    PickUpCropInfoComponent,
    OverviewTableComponent,
    SingleInputDialogComponent,
  ],

  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      { path: 'pick-up', component: PickUpComponent, canActivate: mapToCanActivate([PickUpGuard]) },
      {
        path: 'pick-up/registration',
        component: PickUpRegistrationComponent,
        children: registrationChildren,
        canActivate: mapToCanActivate([CustomerGuard]),
      },
    ]),
    LetDirective,
    PushPipe,
    FormsModule,
    ReactiveFormsModule,
    AgrPageToolbarModule,
    AgrValueRowModule,
    AgrFilterModule,
    AgrPageDetailModule,
    AgrFormModule,
    FormDialogComponent,
    AgrNotificationEmptyModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatInputModule,
    MatCardModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatListModule,
    MatInputModule,
    MatCheckboxModule,
    MatOptionModule,
    MatSelectModule,
    TableV2Module,
    MatSortModule,
    AgrExportModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatSlideToggleModule,
    AgrNotificationEmptyModule,
    MatFormFieldModule,
    TableActionsButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    AgrBlockSpinnerModule,
  ],
  providers: [
    provideState('pickUpModule', reducer),
    provideEffects([PickUpEffects]),
    provideAgrDialog(),
    provideAgrNotification(),
  ],
  exports: [],
})
export class PickUpModule {}
